import moment from 'moment';
class dateClass {
    constructor() {}
    nowDate(now) {
        if (now == '') {
            return moment().format();
        } else {
            return moment(now).format();
        }
    }
    timehhmmss() {
        let nowTime = moment().format('hh:mm:ss');
        return nowTime;
    }
    dateYYYYMM() {
        let now_date = moment().format('YYYYMM');
        return now_date;
    }
    dateYYYYMMDD() {
        let now_date = moment().format('YYYYMMDD');
        return now_date;
    }
    dateYYYYMMDD2(date) {
        let now_date = moment(date).format('YYYYMMDD');
        return now_date;
    }
    dateYYYYMMDD3(date) {
        let now_date = moment(date).format('YYYY-MM-DD');
        return now_date;
    }
    prevYYYYMMDD(now) {
        let now_date = moment(now + '01')
            .add(-1, 'day')
            .format('YYYY-MM-DD');
        return now_date;
    }
    prevYYYYMMDD2(now) {
        let now_date = moment(now)
            .add(-1, 'day')
            .format('YYYY-MM-DD');
        return now_date;
    }
    nextYYYYMMDD2(now) {
        let now_date = moment(now)
            .add(+1, 'day')
            .format('YYYY-MM-DD');
        return now_date;
    }
    prevYYYYMM(now) {
        let now_date = moment(now + '01')
            .add(-1, 'month')
            .format('YYYYMM');
        return now_date;
    }
    prevYYYYMMDD7(now) {
        let now_date = moment(now)
            .add(-7, 'day')
            .format('YYYYMMDD');
        return now_date;
    }

    nextYYYYMM(now) {
        let now_date = moment(now + '01')
            .add(+1, 'month')
            .format('YYYYMM');
        return now_date;
    }

    nextYYYYMMDD7(now) {
        let now_date = moment(now)
            .add(+7, 'day')
            .format('YYYYMMDD');
        return now_date;
    }

    getDate(format) {
        let now_date = moment().format(format);
        return now_date;
    }
    getDay(date) {
        const day = moment(date).day();
        const dayArray = ['일', '월', '화', '수', '목', '금', '토'];

        return dayArray[day];
    }

    nowYear() {
        let date = new Date();
        let now_year = date.getFullYear();
        return now_year;
    }

    nowday() {
        let date = new Date();
        let now_day = date.getDate();
        return now_day;
    }
    nowhour() {
        let date = new Date();
        let now_hour = date.getHours();
        return now_hour;
    }
    nowminute() {
        let date = new Date();
        let now_minute = date.getMinutes();
        return now_minute;
    }

    dateDiff(_date1, _date2) {
        let diffDate_1 = _date1 instanceof Date ? _date1 : new Date(_date1);
        let diffDate_2 = _date2 instanceof Date ? _date2 : new Date(_date2);

        diffDate_1 = new Date(diffDate_1.getFullYear(), diffDate_1.getMonth() + 1, diffDate_1.getDate());
        diffDate_2 = new Date(diffDate_2.getFullYear(), diffDate_2.getMonth() + 1, diffDate_2.getDate());

        let diff = diffDate_2.getTime() - diffDate_1.getTime();
        diff = Math.ceil(diff / (1000 * 3600 * 24));

        return diff;
    }

    // 원장 스케쥴 탭 (전체 -> 당일날짜만 출력, 특정원장 -> 당일부터 3일차까지 출력) filteredDates(), isToday() 추가함
    filteredDates(startDate, endDate, specificDoctor) {
    const currentDate = moment().startOf('day').format("YYYYMMDD"); // 변경된 부분
    let filteredDates = [];
    let date = moment(startDate, "YYYYMMDD"); // 변경된 부분

    if (specificDoctor) {
        while (date.isSameOrBefore(endDate)) {
            if (date.isSameOrAfter(currentDate)) {
                filteredDates.push(date.format("YYYYMMDD")); // 변경된 부분
            }
            if (filteredDates.length >= 3) break;
            date.add(1, "days");
        }
    } else {
        filteredDates.push(currentDate);
    }

    return filteredDates;
    }

    isToday(date) {
    const today = new Date();
    const currentDate = new Date(date);

    return (
        today.getDate() === currentDate.getDate() &&
        today.getMonth() === currentDate.getMonth() &&
        today.getFullYear() === currentDate.getFullYear()
    );
    }

}

export default dateClass = new dateClass();
